import { render, staticRenderFns } from "./ProductListHeader.vue?vue&type=template&id=8778edc0"
import script from "./ProductListHeader.vue?vue&type=script&lang=js"
export * from "./ProductListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports